module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-dashboard"
  }, [_c('div', {
    staticClass: "empty-dashboard__header"
  }, [_vm._v("\n    " + _vm._s(_vm.emptyMessage) + "\n  ")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "empty-dashboard__message"
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c2e1a2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tables/components/EmptyTable.vue
// module id = 1963
// module chunks = 0